import { storyblokEditable } from "gatsby-source-storyblok"

import LogoShowCase from "../../../V2/Banners/LogoShowCase"

import { Color } from "@constants/V2/color"
import { useMerchantLogos } from "@hooks/V2/storyblok/useMerchantLogos"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import { getComponentColorTheme } from "@utils/V2/color"
import React from "react"

const StoryblokLogoShowCase = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.LogoShowCase>) => {
  const merchantLogos = useMerchantLogos(blok.useInternalLogos)
  const backgroundColor = blok.backgroundColor || Color.White
  const hasDarkBackground = getComponentColorTheme(backgroundColor) === "dark"

  const displayedLogos = blok.logos?.length
    ? blok.logos.flatMap((logoId) =>
        merchantLogos.filter((logo) => logo.uuid === logoId)
      )
    : merchantLogos.filter(
        (logo) =>
          !blok.industry || logo.content.industries?.includes(blok.industry)
      )

  if (displayedLogos.length === 0) return null

  return (
    <LogoShowCase
      title={blok.title}
      backgroundColor={backgroundColor}
      rounded={blok.rounded}
      callout={blok.callout?.[0]}
      mobileGridOrder={mobileGridOrder}
      desktopOrientation={blok.desktopOrientation}
      logos={displayedLogos.map((logo) => {
        const icon =
          hasDarkBackground && logo.content.lightIcon?.filename
            ? logo.content.lightIcon
            : logo.content.darkIcon

        return {
          id: logo.uuid,
          imageUrl: icon.filename,
          alt: icon.alt || logo.name,
          link: storyblokLinkToYocoLink(logo.content.ctaLink),
        }
      })}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokLogoShowCase
